import React from 'react';

import {
  Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink
} from 'reactstrap';
import Icon from './icon';
// import { connect } from 'react-redux'
// import { SetLoggedIn } from './redux/actions'
// // import store from './redux/store'
// import classNames from 'classnames'
// import ReactDom from 'react-dom';
import logo from './assets/logo.png';

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    // this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      selected: 1
    };
    // this.vaibhav = props.refs;
    // this.logout = this.logout.bind(this)
  }
  // handleClick = () => {
  //   const x = ReactDom.findDOMNode(this.vaibhav.gallery);
  //   x.scrollIntoView();
  // }
  // toggle() {
  //   this.setState({
  //     isOpen: !this.state.isOpen
  //   });
  // }

  // logout() {
  //   this.props.history.replace('/login');
  // }
  render() {
    return (
      <div>
        <Navbar color="faded" expand="md" className="header">
          <NavbarBrand onClick={() => this.props.refss('home')}>
          <img src={logo} height={40} alt="logo"/>
            <div className="header-logo">
              <div className="logo-peacock"></div>
              {/* <Logo fill="#f96e0a" /> */}
            </div>
          </NavbarBrand>

          <NavbarToggler className="icon-menu" onClick={this.toggle}>
            {!this.state.isOpen ? <Icon icon="fa-bars" /> : <Icon icon="fa-times" />}
          </NavbarToggler>

          <Collapse isOpen={this.state.isOpen} navbar>
            <MenuList onSelect={this.props.refss} selected={this.state.selected}/>
          </Collapse>

        </Navbar>
      </div>
    );
  }
}
export const MenuList = (props) => {
  return (
    <Nav className="ml-auto" navbar>
      <NavItem>
        <NavLink onClick={() => props.onSelect('home')} className="nav-hover">
          <Icon icon="fa-home" /> Home</NavLink>
      </NavItem>
      <NavItem>
        <NavLink onClick={() => props.onSelect('services')}
         className="nav-hover"
        ><Icon icon="fa-images" /> Services</NavLink>
      </NavItem>
      <NavItem>
        <NavLink onClick={() => props.onSelect('plans')} className="nav-hover"><Icon icon="fa-cart-arrow-down" /> Tariff plans
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink onClick={() => props.onSelect('about')} className="nav-hover"><Icon icon="fa-info-circle" /> About Us</NavLink>
      </NavItem>
      {/* <Login onLogOut={this.logout} /> */}
    </Nav>
  )
}